
export function convertDate(dateString:string) {
    let reg_pattern = /\d{4}\/\d{2}\/\d{2}/

  
    // let month= new Date(strDate).getMonth() <10?`0${new Date(strDate).getMonth() + 1}`:new Date(strDate).getMonth() + 1
    // let day =new Date(strDate).getDate() <10? `0${new Date(strDate).getDate()}`:new Date(strDate).getDate()
    // let formatedDate= new Date(strDate).getFullYear()+'/'+
    // month
    //  +'/'+day
    // return formatedDate
    var date = new Date(dateString);
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);
  return year + "/" + month + "/" + day;
}